import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  OverflowTooltip,
  Space,
} from '@tonic-one/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PasswordExtractionRulesItem } from '../../../../types/globalSetting';
import { AddInput } from '../AddInput';

export const AddModal = React.memo(
  (props: {
    visible: boolean;
    onSave: (value: PasswordExtractionRulesItem) => void;
    onClose: () => void;
    title: string;
  }) => {
    const { t } = useTranslation();
    const [isSaveDisable, setSaveDisable] = useState(true);
    const [value, setValue] = useState<PasswordExtractionRulesItem>({
      itemKey: '',
      enableScan: false,
      prefix: '',
      matchPart: '',
      suffix: '',
      ignoreCase: false,
      regex: '',
    });
    return (
      <Modal
        closeOnEsc
        closeOnOutsideClick={false}
        isClosable
        isOpen={props.visible}
        onClose={props.onClose}
        size="lg"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <OverflowTooltip>{props.title}</OverflowTooltip>
          </ModalHeader>
          <ModalBody>
            <AddInput onChange={setValue} isSaveDisable={setSaveDisable} />
          </ModalBody>
          <ModalFooter>
            <Button
              variant="primary"
              minWidth="20x"
              disabled={isSaveDisable}
              onClick={() => {
                console.log(value);
                props.onSave(value);
              }}
            >
              {t('common.button.save')}
            </Button>
            <Space width="2x" />
            <Button minWidth="20x" onClick={props.onClose}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
);
